import React, { useState, useEffect, Fragment } from "react";
import ApexChart from "components/ApexChart/ApexChart";
import "./ProductionStatistics.scss";
import { IoIosWarning } from "react-icons/io";
import { FaSun, FaCloudSun, FaMoon } from "react-icons/fa";
import { LuAlarmClock } from "react-icons/lu";
import RewardCard from "components/RewardCard/RewardCard";
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css'; // Importing the styles
import { Switch, Tooltip } from "antd";
import FullPageLoader from "components/FullPageLoader/FullPageLoader";


const boxBorderColors = ["#3b4d61", "#1e847f", "#3b4d61", "#1e847f"];
const ProductionStatisticsDashBoard = ({apiData, isLoading}) => {

  const chartStyleConfig = {
    className: "chart-element",
    height: "35%",
    width: "100%",
    axisShow: true,
    axisType: null,
    showGrid: true,
    strokeConfig: {
      curve: 'smooth',
      width: 4,
    },
  };


const ShiftCard = ({selectedShift}) => {

  const shiftData = [
    { name: "A", icon: <FaSun />, color: "#f39c12" },
    { name: "B", icon: <FaCloudSun />, color: "#3498db" }, 
    { name: "C", icon: <FaMoon />, color: "#8e44ad" }, 
  ];

  const currentShift = shiftData.find((shift) => shift.name === selectedShift);
  const currentShiftIcon = currentShift ? currentShift.icon : <LuAlarmClock />;
  const currentShiftColor = currentShift ? currentShift.color : "#7f8c8d"; 

  return (
    <div className="shift-container">
      <div className="top-section">
        <h3 className="shift-label">
          <span className="shift-icon" style={{ color: currentShiftColor }}>
            {currentShiftIcon}
          </span>
          &nbsp;Shift Running:
        </h3>
        <div className="button-group">
          <button key={selectedShift} className='button active'>
            {selectedShift || 'NA'}
          </button>
        </div>
      </div>
    </div>
  );
};



  const chartBox = ({
    type,
    series,
    categories,
    styleConfig,
    color,
    labels = [],
    showLegend = true,
    name,
    material,
    packed_qty,
    progress,
    axisValues,
    info,
  }) => {

    return (
      <div className={styleConfig.className || ""} style={{ position: 'relative' }}>
      <p style={{fontSize: '1.5rem',
                fontWeight: 'bold',
                margin: '5px auto',
                color: '#263238'}}>{name}</p>
       <p style={{fontSize: '1.7rem',
                fontWeight: 'bold',
                margin: '0 auto',
                color: '#263238'}}>{material}</p>

       <hr style={{border: '1px solid #000', margin: '0 13px'}}></hr>

        <div style={{ width: 100, height: 100, margin: "18px auto" }}>
          <CircularProgressbar
            value={progress}
            text={`${Math.round(progress)}%`}
            styles={{
              root: {},
              path: {
                stroke:'#2196F3',
                strokeLinecap: 'round',
              },
              trail: {
                stroke: '#d6d6d6',
                strokeLinecap: 'round',
              },
              text: {
                fill: '#333', 
                fontSize: '25px', 
                fontWeight: 'bold', 
              },
            }}
          />
        </div>
        <p style={{fontSize: '2.7rem',
                fontWeight: 'bold',
                margin: '0 auto',
                color: '#263238'}}>{`Units: ${packed_qty}`}</p>
       <hr style={{border: '1px solid #000', margin: '0 13px'}}></hr>
      
        <ApexChart
          type={type}
          series={series}
          categories={categories}
          labels={type === "pie" || type === "donut" ? labels : undefined}
          height={styleConfig.height}
          width={styleConfig.width}
          colors={color}
          axisValues={axisValues}
          strokeConfig={styleConfig.strokeConfig}
          axisConfig={{
            show: styleConfig.axisShow,
            axisType: styleConfig.axisType,
            showGrid: styleConfig.showGrid,
            showXaxis: true,
            showYaxis: true,
          }}
          legendConfig={{ show: showLegend }}
          name={name}
          isLoading={isLoading}
        />
      </div>
    );
  };



  if(isLoading){
    return <FullPageLoader />
  }

  const renderCategoryCharts = (linedetails) => {
    const chartType = 'bar';
    let series = [];
    let parsedData = JSON.parse(linedetails?.hourly_data);
    if (Array.isArray(parsedData)) {
    const hours = parsedData.map((item) => parseInt(item.hour, 10))
    const hourQty = parsedData.map((item) => parseFloat(item.hour_qty))
    if (chartType === "bar" || chartType === "column") {
      series = [{ name: 'Hour Qty', data:hourQty || [] }];
    } else {
      return null;
    }
        return (
          <Fragment key={linedetails.name}>
            {hourQty && 
              chartBox({
              type: chartType,
              series,
              styleConfig: chartStyleConfig,
              color: ["#2196F3", "#E0E0E0"],
              name: linedetails.line_name,
              material: linedetails.material_name,
              packed_qty: linedetails.packed_qty,
              progress:linedetails.line_percent,
              axisValues:{hours, hourQty},
              isToggle: false,
            })}
          </Fragment>
        );
      } else {
        console.error('Invalid hourly_data format:', linedetails?.hourly_data);
        return null;
    }
  };

  return (
    <div className="dashboard-container">
        <h4>Production Statistics</h4>
        <div className="title-container">
              <div className="column-1">
                  <div className="reward-cards">
                      {apiData?.milestone && apiData?.milestone?.map((el) => (
                          <div key={el.type}>
                              <RewardCard
                                  count={el.qty}
                                  attribute={el.name}
                                  icon={el.icon}
                                  date={el.date}
                              />
                          </div>
                      ))}
                  </div>
              </div>

              <div className="column-2">
                  <div className="location-card">
                      <div className="location-card__flag">
                          <span className="location_icon">
                              <i className="fa fa-map-marker" aria-hidden="true"></i>
                          </span>
                          <div className="location-card__text">
                              <h3 className="location-card__title">Location:</h3>
                              <div className="location-card__location">{apiData?.location_name || 'NA'}</div>
                          </div>
                      </div>    
                  </div>

                  <ShiftCard selectedShift={apiData?.shift_name} />
              </div>
          </div>

          <div className="section-card__count">
        <div className="section-title">Production Summary</div>
        <div className="count-box">
          {apiData?.day_data && apiData?.day_data.length > 0 ? (
            apiData?.day_data.map((transaction, index) => {
            const Icon = transaction.icon
            return (
            <div className="count-items" key={transaction.name} style={{ borderBottom: `0.31rem solid ${boxBorderColors[index]}` }}>
              <div className="count-title">
                {transaction.name}
              </div>

              <div className="count-block">
                <div className="total-count">
                  {transaction.count.split("(")[0].length > 11 ? 
                  <Tooltip title={transaction.count} placement="top"> 
                  {`${transaction.count.split("(")[0].slice(0, 10).trim()}... (${transaction.count.split("(")[1]}`} 
                  </Tooltip> : transaction.count}</div>
                <div className="icon">
                  <img style={{ width: '3.5rem', height: '3.5rem' }} src={Icon} alt={`${transaction.name} icon`} />
                </div>
              </div>

            </div>
          );
          })
        ):( 
          <div className="no-data-message">
          <IoIosWarning />
          <span>No Data Available</span>
        </div>
      )}
        </div>
      </div>

          

      <div className="packing-section__card">
      <div className="section-title">Production Line Overview</div>
        {apiData?.line_data && apiData.line_data.length > 0 ? (
          apiData?.line_data?.map((linedetails, index) => {
          return (
            <>
            <div className="chart-box" key={index}>
                {renderCategoryCharts(linedetails)}
            </div>
            </>
          );
        })
      ):(
        <div className="no-data-message">
          <IoIosWarning />
          <span>No Data Available</span>
        </div>
      )}
      </div>
    </div>
  );
};

export default ProductionStatisticsDashBoard;
